// extracted by mini-css-extract-plugin
export default {"actionWrap":"ListJobs_actionWrap__VtwgG","emptyData":"ListJobs_emptyData__Evd5D"};